import axios from 'axios'

// 同源相对路径,生产走 Nginx 反代到 PocketBase,开发期走 webpack-dev-server proxy
const http = axios.create({
  baseURL: '',
  timeout: 15000
})

http.interceptors.response.use(
  function (res) { return res },
  function (err) {
    if (process.env.NODE_ENV !== 'production') {
      var cfg = err && err.config ? err.config : {}
      console.warn('[HTTP]', cfg.url, err && err.message)
    }
    return Promise.reject(err)
  }
)

export default http



// WEBPACK FOOTER //
// ./src/api/index.js